<template>
  <div class="custom-rate">
    <div class="custom-rate-stars">
      <span
        v-for="(star, index) in maxStars"
        :key="index"
        class="star-item"
        :class="{ active: index < displayValue, disabled: disabled }"
        @click="handleClick(index + 1)"
        @mouseenter="handleMouseEnter(index + 1)"
        @mouseleave="handleMouseLeave"
      >
        <img
          :src="index < displayValue ? starActiveIcon : starIcon"
          :alt="`star-${index + 1}`"
          class="star-icon"
        />
      </span>
    </div>
    <span v-if="showScore && scoreText" class="score-text">{{ scoreText }}</span>
  </div>
</template>

<script>
import starIcon from '@/assets/star.png'
import starActiveIcon from '@/assets/star-active.png'

export default {
  name: 'CustomRate',
  props: {
    value: {
      type: Number || String,
      default: 0
    },
    max: {
      type: Number,
      default: 5
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showScore: {
      type: Boolean,
      default: false
    },
    scoreTemplate: {
      type: String,
      default: '{value}'
    },
    allowHalf: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      starIcon,
      starActiveIcon,
      hoverValue: 0
    }
  },
  computed: {
    maxStars() {
      return this.max
    },
    displayValue() {
      if (this.hoverValue) {
        return this.hoverValue
      }
      // 对评分值进行四舍五入
      return Math.round(this.value)
    },
    scoreText() {
      if (!this.showScore) return ''
      const score = this.value || 0
      return this.scoreTemplate.replace('{value}', score.toFixed(1))
    }
  },
  methods: {
    handleClick(index) {
      if (this.disabled) return
      this.$emit('input', index)
      this.$emit('change', index)
    },
    handleMouseEnter(index) {
      if (this.disabled) return
      this.hoverValue = index
    },
    handleMouseLeave() {
      if (this.disabled) return
      this.hoverValue = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-rate {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  .custom-rate-stars {
    display: inline-flex;
    align-items: center;
    gap: 4px;

    .star-item {
      display: inline-block;
      cursor: pointer;
      transition: transform 0.2s;

      &:hover:not(.disabled) {
        transform: scale(1.1);
      }

      &.disabled {
        cursor: not-allowed;
      }

      .star-icon {
        display: block;
        width: 16px;
        height: 16px;
        user-select: none;
      }
    }
  }

  .score-text {
    font-size: 14px;
    color: #333;
  }
}
</style>

